export const my_listings_detail = {
  back_aria: "Back to my listings",
  header_active_listing: "Active Listing",
  header_pending_listing: "Pending Listing",
  header_past_sale: "Past Sale",
  header_removed_listing: "Removed Listing",
  header_listing: "Listing",
  modify_listing: "Modify Listing",
};
